import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { ConcluirCadastroRoutingModule } from './concluir-cadastro-routing.module';
import { ConcluirCadastroComponent } from './concluir-cadastro.component';
import { ContaService } from '../../shared/services/conta/conta.service';
import { DirectivesModule } from '../../shared/directives/directives.module';
import { FormsModule } from '@angular/forms';

import { NgxMaskModule } from 'ngx-mask';
import { PendenciasService } from '../../shared/services/pendencias/pendencias.service';
import { ModalDetailDocComponent } from '../../shared/components/modal-detail-doc/modal-detail-doc.component';

import { WebcamModule } from 'ngx-webcam';

@NgModule({
  imports: [
    CommonModule,
    ConcluirCadastroRoutingModule,
    HttpClientModule,
    DirectivesModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    WebcamModule
  ],
  declarations: [
    ConcluirCadastroComponent,
    ModalDetailDocComponent
  ],
  providers: [
    ContaService,
    PendenciasService,
  ]
})
export class ConcluirCadastroModule { }



// WEBPACK FOOTER //
// ./src/app/modules/concluir-cadastro/concluir-cadastro.module.ts